import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BranchHttpService } from 'src/app/http/branch-http.service';
import { MediaLibraryHttpService } from 'src/app/http/media-library-http.service';
import { EventsService } from 'src/app/services/events.service';
import { SharedService } from 'src/app/services/shared.service';
import { MediaModalComponent } from 'src/app/shared/modals/media-modal/media-modal.component';
import { Location } from '@angular/common';
import { SectionHttpService } from 'src/app/http/section-http.service';

@UntilDestroy()
@Component({
    selector: 'app-section-new',
    templateUrl: './section-new.component.html',
    styles: [],
})
export class SectionNewComponent implements OnInit {
    constructor(
        private fb: FormBuilder,
        private sectionHttpService: SectionHttpService,
        private sharedService: SharedService,
        private router: Router,
        public location: Location,
        private mediaLibraryHttpService: MediaLibraryHttpService,
        private modalService: NgbModal,
        private eventsService: EventsService,
        private activatedRoute: ActivatedRoute
    ) {}

    newSectionForm = this.fb.group({
        sectionName: [null, Validators.required],
        sectionDesc: [null],
        index: [null],
        assetId: [null],
        isFeatured: [false],
        isPublished: [false],
        isSectionOffer: [false],
        sectionOfferProduct: this.fb.array([]),
    });

    formBusy: boolean;

    selectAsset: any;

    products: any[] = [];

    ngOnInit(): void {
        this.addNewEmptyLine();
        this.eventsSub();
        this.routeData();
        this.isSectionOfferValueChange();
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.products = data.data;
        });
    }

    eventsSub() {
        this.eventsService.trigger.pipe(untilDestroyed(this)).subscribe((data) => {
            if (data.name === 'selectedAsset') {
                const selected = data.value.slice(-1).pop();
                if (selected) {
                    this.selectAsset = selected;
                    this.newSectionForm.controls['assetId'].setValue(selected.assetId);
                }
            }
        });
    }

    onSubmit() {
        this.newSectionForm.markAsTouched();
        if (this.newSectionForm.valid) {
            this.formBusy = true;
            let value = this.newSectionForm.value;

            value.sectionOfferProduct.forEach((element: any, index: number) => {
                if (!element.productId) {
                    value.sectionOfferProduct.splice(index, 1);
                }
            });

            this.sectionHttpService.newSection(value).subscribe(
                () => {
                    this.router.navigateByUrl('section-list', {
                        state: { hasState: true, type: 'success', message: 'Section Created successfully' },
                    });
                },
                () => {
                    this.formBusy = false;
                    this.newSectionForm.setErrors({ exists: true });
                }
            );
        }
    }

    openMedia() {
        this.mediaLibraryHttpService.getAllFolders().subscribe((folders) => {
            let media = this.modalService.open(MediaModalComponent, { size: 'xl', windowClass: 'media-library' });
            media.componentInstance.folders = folders;
        });
    }

    clearImages() {
        this.selectAsset = null;
        this.newSectionForm.controls['assetId'].setValue(null);
    }

    isSectionOfferValueChange() {
        this.newSectionForm.controls['isSectionOffer'].valueChanges.subscribe((data) => {
            if (data) {
            } else {
            }
        });
    }

    addNewEmptyLine() {
        let sectionOfferProduct = <FormArray>this.newSectionForm.controls['sectionOfferProduct'];
        sectionOfferProduct.push(
            this.fb.group({
                productId: [null],
            })
        );
    }

    onProductChange(ev: any, index: number) {
        let item = this.sectionOfferProduct.at(index) as FormGroup;

        if (ev) {
            this.addNewEmptyLine();
        }
    }

    deleteLine(index: number) {
        if (this.sectionOfferProduct.length > 1) {
            this.sectionOfferProduct.removeAt(index);
        }
    }

    get sectionOfferProduct() {
        return this.newSectionForm.controls['sectionOfferProduct'] as FormArray;
    }

    ngOnDestroy(): void {
        this.eventsService.trigger.next({ name: null, value: null });
    }
}
